import {type IntlShape} from 'react-intl';
import {createFinancialCategoryTooltip as createTooltip} from '@/components/insights/FinancialCategoryTooltip';
import {type TooltipFormulaItem} from '@/components/TooltipFormulaRenderer';

type FormatMessage = IntlShape['formatMessage'];

const ActualHoursTooltipItems = (formatMessage: FormatMessage): TooltipFormulaItem[] => [
	{
		title: formatMessage({id: 'common.actual_hours'}),
		description: formatMessage({id: 'financial.time_reg_report.actual_hours.tooltip.description'}),
	},
];

const ActualBillableHoursTooltipItems = (formatMessage: FormatMessage): TooltipFormulaItem[] => [
	{
		title: formatMessage({id: 'common.actual_billable_hours'}),
		description: formatMessage({id: 'financial.time_reg_report.actual_billable_hours.tooltip.description'}),
	},
];

const ActualNonBillableHoursTooltipItems = (formatMessage: FormatMessage): TooltipFormulaItem[] => [
	{
		title: formatMessage({id: 'common.actual_non_billable_hours'}),
		description: formatMessage({id: 'financial.time_reg_report.actual_non_billable_hours.tooltip.description'}),
	},
];

const ActualBillableValueOfServiceTooltipItems = (formatMessage: FormatMessage): TooltipFormulaItem[] => [
	{
		title: formatMessage({id: 'common.actual_billable_value_of_service'}),
		description: formatMessage({id: 'financial.time_reg_report.actual_billable_value_of_service.tooltip.description'}),
		details: [formatMessage({id: 'common.actual_billable_hours'}), 'x', formatMessage({id: 'common.rate'})],
	},
];

const ActualCostTooltipItems = (formatMessage: FormatMessage): TooltipFormulaItem[] => [
	{
		title: formatMessage({id: 'common.actual_cost'}),
		description: formatMessage({id: 'financial.time_reg_report.actual_cost.tooltip.description'}),
		details: [formatMessage({id: 'common.actual_hours'}), 'x', formatMessage({id: 'common.internal_hourly_cost'})],
	},
];

export const TimeRegistrationReportTooltips = {
	ActualHoursTooltip: createTooltip(ActualHoursTooltipItems),
	ActualBillableHoursTooltip: createTooltip(ActualBillableHoursTooltipItems),
	ActualNonBillableHoursTooltip: createTooltip(ActualNonBillableHoursTooltipItems),
	ActualBillableValueOfServiceTooltip: createTooltip(ActualBillableValueOfServiceTooltipItems),
	ActualCostTooltip: createTooltip(ActualCostTooltipItems),
};
